import { TextWithLinks } from "../common/TextWithLinks"

export const ShortDescriptionModalBody = ({ text }: { text: string }) => {
  return <TextWithLinks text={text} />
}

/** @deprecated Use ShortDescriptionModalBody — alias for full-description modals */
export const FullDescriptionModalBody = ShortDescriptionModalBody
